import type { FC, ReactNode } from 'react'

import dynamic from 'next/dynamic'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { siteConfig } from '@/constants/site'

// The 3D game draws on a canvas, so it only runs in the browser.
const GameShell = dynamic(() => import('@/components/game/game-shell'), {
    ssr: false,
    loading: () => (
        <div className='fixed inset-0 flex flex-col items-center justify-center gap-4 bg-gradient-to-b from-sky-400 via-sky-300 to-emerald-300 p-6 text-center'>
            <p className='rounded-3xl border-[5px] border-slate-900 bg-yellow-400 px-6 py-4 font-heading text-4xl font-bold text-slate-900 shadow-[0_8px_0_0_#0f172a]'>
                Phonics Grand Prix
            </p>
            <p className='font-heading text-xl font-bold text-slate-900'>
                {siteConfig.placeholder}
            </p>
        </div>
    )
})

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />
            <h1 className='sr-only'>
                Phonics Grand Prix: CVC Race, a 3D phonics racing adventure for Year 1
            </h1>
            <GameShell />
        </Layout>
    )
}

export default Home
